export enum SessionStorageKeys {
  ELAPSED_SPLASH = 'elapsedSplash',
  SESSIONID = 'sessionId',
  APP_STARTUP_TIME = 'appStartUpTime',
  STOREFRONT_START = 'storefrontStart',
  CONF_START = 'confStart',
  ELAPSED_STOREFRONT = 'elapsedStorefront',
  ACTIVATION_CODE = 'activationCode',
}
